import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.breadcrumb),function(item,index){return _c('span',{staticClass:"breadcrump"},[_c('span',{class:[(index === _vm.breadcrumb.length - 1) ? 'tela-atual' : undefined]},[_vm._v("\n      "+_vm._s(item)+"\n    ")]),(index !== _vm.breadcrumb.length - 1)?_c('span',{staticClass:"px-1"},[_c(VIcon,{attrs:{"size":"15"}},[_vm._v("$CaretRight")])],1):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }